import React from 'react';
import PropTypes from 'prop-types';
import { cloneObject } from '../../common/utils';
import Icon from '../elements/Icon';

const IconWithText = (
  {
    wrapperProps: receivedWrapperProps = {},
    iconProps: receivedIconProps = {},
    textProps: receivedTextProps = {},
    wrapperClasses = [],
    iconName,
    iconClasses = [],
    iconTitle,
    text,
    textClasses = [],
    pullIconRight
  }
) => {
  const iconProps = cloneObject(receivedIconProps, { iconName, 'aria-hidden': true });

  if (iconTitle) {
    iconProps.title = iconTitle;
  }

  // Do not wrap if either part is missing:
  if (!iconName || !text) {
    return text || <Icon {...iconProps} />;
  }

  const wrapperProps = cloneObject(receivedWrapperProps);
  const textProps = cloneObject(receivedTextProps);
  const mainWrapperClass = 'icon-with-text';

  iconProps.className = [...iconClasses, `${mainWrapperClass}__icon`].join(' ');
  textProps.className = [...textClasses, `${mainWrapperClass}__text`].join(' ');

  if (wrapperClasses.indexOf(mainWrapperClass) === -1) {
    wrapperClasses.push(mainWrapperClass);
  }

  const { className } = wrapperProps;

  if (className) {
    wrapperClasses.push(className);
    delete wrapperProps.className;
  }

  const iconElement = iconName ? <Icon key='icon' {...iconProps} /> : null;
  const textElement = text ? <div key='text' {...textProps}>{text}</div> : null;
  const arrangement = pullIconRight ? [textElement, iconElement] : [iconElement, textElement];

  return <div className={wrapperClasses.join(' ')} {...wrapperProps}>{arrangement}</div>;
};

IconWithText.propTypes = {
  wrapperClasses: PropTypes.arrayOf(PropTypes.string),
  wrapperProps: PropTypes.object,
  iconName: PropTypes.string,
  iconClasses: PropTypes.arrayOf(PropTypes.string),
  iconProps: PropTypes.object,
  iconTitle: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  textClasses: PropTypes.arrayOf(PropTypes.string),
  textProps: PropTypes.object,
  pullIconRight: PropTypes.bool
};

export default IconWithText;